import { useAuth } from './features/auth/AuthContext';
import { LoginPage } from './features/auth/LoginPage';
import { Shell } from './app/Shell';
import { PeriodProvider } from './app/PeriodContext';

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-sm text-slate-400">Carregando…</div>
      </div>
    );
  }

  // O provedor de período fica DENTRO da checagem de sessão: ele lê o
  // localStorage no primeiro render, e não faz sentido montá-lo na tela de
  // login, onde não há nada para filtrar.
  return user ? (
    <PeriodProvider>
      <Shell />
    </PeriodProvider>
  ) : (
    <LoginPage />
  );
}